import { render, staticRenderFns } from "./OrderPerformances.vue?vue&type=template&id=1c73460c&scoped=true"
import script from "./OrderPerformances.vue?vue&type=script&lang=js"
export * from "./OrderPerformances.vue?vue&type=script&lang=js"
import style0 from "./OrderPerformances.vue?vue&type=style&index=0&id=1c73460c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73460c",
  null
  
)

export default component.exports